module.exports = __webpack_public_path__ + "static/media/29_plantilla_rec_combo_duo_cp_aguas_pet_591_swsg.c2df3b7e.png";